import { render, staticRenderFns } from "./WidgetSmallParcelStillToShip.vue?vue&type=template&id=168ba0a2"
import script from "./WidgetSmallParcelStillToShip.vue?vue&type=script&lang=js"
export * from "./WidgetSmallParcelStillToShip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports